import React, { useEffect, useState } from 'react';

import {
  Pagination,
  Stack,
  CircularProgress,
  Grid,
  Modal,
} from '@mui/material';

import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { Box } from '@mui/material';
import { Button } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Swal from 'sweetalert2';
import secureLocalStorage from 'react-secure-storage';
import EditIcon from '@mui/icons-material/Edit';
import Fade from '@mui/material/Fade';
import Backdrop from '@mui/material/Backdrop';
import SearchIcon from '@mui/icons-material/Search';
import CummonTable from '../../Common/CummonTable';
import FetchLoading from './../../Loading/FetchLoading';
import commaNumber from 'comma-number';
import { format } from 'date-fns';
import { createMRTColumnHelper } from 'material-react-table';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2564b8',
      darker: '#2564b8',
    },
  },
});

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: '#fff',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const AccountDetails = () => {
  const adminInfo = secureLocalStorage.getItem('admin-info');
  const token = adminInfo?.token;
  const [userData, setUserData] = useState(null);
  console.log(adminInfo);
  const [open, setOpen] = useState(false);

  const handleOpen = (data) => {
    setUserData(data);

    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const navigate = useNavigate();
  const [paymentData, setPaymentData] = useState([]);

  const [isLoading, setIsloading] = useState(false);
  const [refetch, setRefetch] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevUserData) => ({
      ...prevUserData,
      [name]: value,
    }));
  };

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor('firstname', {
      header: 'First Name',
    }),
    columnHelper.accessor('lastname', {
      header: 'Last Name',
    }),
    columnHelper.accessor('status', {
      header: 'Status',
      Cell: ({ row }) => (
        <Box className={`${row.original.status?.toLowerCase()}-btn`}>
          {row.original.status}
        </Box>
      ),
    }),
    columnHelper.accessor('email', {
      header: 'Email',
      size: '10px',
    }),
    columnHelper.accessor('role', {
      header: 'Role',
      Cell: ({ row }) =>
        `${row.original?.role === 'Admin' ? 'Sub Admin' : row.original?.role}`,
    }),
    columnHelper.accessor('phone', {
      header: 'Phone',
    }),
    columnHelper.accessor('created_at', {
      header: 'Date',
      size: 20,
      Cell: ({ row }) =>
        `${
          row.original?.created_at !== '' || 'undefined' || null
            ? format(new Date(row.original?.created_at), 'dd MMM yy hh:mm')
            : 'Fly Date'
        }`,
    }),
    columnHelper.accessor('Operation', {
      header: 'Operation',
      size: 20,
      Cell: ({ row }) => (
        <EditIcon
          style={{
            color: 'var(--primary-color)',
            fontSize: '22px',
            marginRight: '10px',
            cursor: 'pointer',
          }}
          onClick={() => handleOpen(row.original)}
        />
      ),
    }),
  ];

  useEffect(() => {
    const apiUrl = 'https://api-b2b.businesssolutions.ae/admin';
    fetch(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`, // Include the token in the header
      },
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        setPaymentData(data);
        setIsloading(true);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setIsloading(false);
      });
  }, [refetch]);

  const handleAdd = (e) => {
    e.preventDefault();

    let url = `https://api-b2b.businesssolutions.ae/admin/${userData?.uid}`;

    fetch(url, {
      method: 'PATCH',
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`, // Include the token in the header
      },
      body: JSON.stringify({
        firstname: userData?.firstname,
        lastname: userData?.lastname,
        password: userData?.password,
        phone: userData?.phone,
        status: userData?.status,
        role: userData?.role,
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! Status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        setOpen(false);
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Update Successfully',
          confirmButtonText: 'OK',
        }).then(() => {
          setOpen(false);
          setRefetch(!refetch);
        });
      })
      .catch((error) => {
        console.error('Error updating data:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to update data. Please try again.',
          confirmButtonText: 'OK',
        }).then(() => {
          setOpen(false);
        });
      });
  };

  return (
    <Box>
      <Box
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          sx={{
            fontWeight: 500,
            fontSize: '24px',
            color: '#222222',
            fontFamily: 'poppins',
          }}
        >
          User Accounts
        </Typography>

        <Button
          style={{
            padding: '5px 10px',
            color: 'var(--white)',
            background: 'var(--secondary-color)',
            border: 'none',
            cursor: 'pointer',
            borderRadius: '4px',
            textTransform: 'capitalize',
            fontSize: '14px',
          }}
          onClick={() => {
            navigate('/dashboard/addstaff');
          }}
        >
          Add Account
        </Button>
      </Box>
      <Box mt={1}>
        {isLoading ? (
          <CummonTable data={paymentData} columns={columns} pageSize={15} />
        ) : (
          <FetchLoading />
        )}
      </Box>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <Box mt={2}>
              <Typography
                sx={{
                  fontWeight: '500px',
                  fontSize: '23px',
                  color: '#003566',
                  textAlign: 'center',
                }}
                mb={2}
              >
                Update Admin
              </Typography>

              <form onSubmit={handleAdd}>
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={2} md={4}>
                    <Box>
                      <Typography
                        mb={1}
                        style={{
                          color: 'var(--primary-color)',
                          fontSize: '14px',
                        }}
                      >
                        First Name
                      </Typography>
                      <input
                        required
                        type="text"
                        name="firstname"
                        style={{
                          border: 'none',
                          borderBottom: '1px solid var(--black)',
                          width: '100%',
                          outline: 'none',
                        }}
                        placeholder="First Name"
                        value={userData?.firstname}
                        onChange={handleChange}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={2} md={4}>
                    <Box>
                      <Typography
                        style={{
                          color: 'var(--primary-color)',
                          fontSize: '14px',
                        }}
                        mb={1}
                      >
                        Last Name
                      </Typography>
                      <input
                        required
                        type="text"
                        name="lastname"
                        style={{
                          border: 'none',
                          borderBottom: '1px solid var(--black)',
                          width: '100%',
                          outline: 'none',
                        }}
                        placeholder="First Name"
                        value={userData?.lastname}
                        onChange={handleChange}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={2} md={4}>
                    <Box>
                      <Typography
                        mb={1}
                        style={{
                          color: 'var(--primary-color)',
                          fontSize: '14px',
                        }}
                      >
                        Email
                      </Typography>
                      <input
                        required
                        type="email"
                        name="email"
                        style={{
                          border: 'none',
                          borderBottom: '1px solid var(--black)',
                          width: '100%',
                          outline: 'none',
                        }}
                        placeholder="Email"
                        value={userData?.email}
                        onChange={handleChange}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={2} md={4}>
                    <Box>
                      <Typography
                        mb={1}
                        style={{
                          color: 'var(--primary-color)',
                          fontSize: '14px',
                        }}
                      >
                        Password
                      </Typography>
                      <input
                        required
                        type="text"
                        name="password"
                        style={{
                          border: 'none',
                          borderBottom: '1px solid var(--black)',
                          width: '100%',
                          outline: 'none',
                        }}
                        placeholder="password"
                        value={userData?.password}
                        onChange={handleChange}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={2} md={4}>
                    <Box>
                      <Typography
                        mb={1}
                        style={{
                          color: 'var(--primary-color)',
                          fontSize: '14px',
                        }}
                      >
                        Contact Number
                      </Typography>
                      <input
                        required
                        type="text"
                        name="phone"
                        style={{
                          border: 'none',
                          borderBottom: '1px solid var(--black)',
                          width: '100%',
                          outline: 'none',
                        }}
                        placeholder="phone"
                        value={userData?.phone}
                        onChange={handleChange}
                      />
                    </Box>
                  </Grid>
                  {userData?.role === 'Super admin' ? null : (
                    <>
                      {' '}
                      <Grid item xs={12} sm={2} md={4}>
                        <Box>
                          <Typography
                            mb={1}
                            style={{
                              color: 'var(--primary-color)',
                              fontSize: '14px',
                            }}
                          >
                            Status
                          </Typography>

                          <select
                            name="status"
                            value={userData?.status}
                            onChange={handleChange}
                            style={{
                              border: 'none',
                              borderBottom: '1px solid var(--black)',
                              width: '100%',
                              outline: 'none',
                            }}
                          >
                            <option>Select Status</option>
                            <option value={'active'}>Active</option>
                            <option value={'deactive'}>Deactive</option>
                          </select>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={2} md={4}>
                        <Box>
                          <Typography
                            mb={1}
                            style={{
                              color: 'var(--primary-color)',
                              fontSize: '14px',
                            }}
                          >
                            Role
                          </Typography>

                          <select
                            name="role"
                            value={userData?.role}
                            onChange={handleChange}
                            style={{
                              border: 'none',
                              borderBottom: '1px solid var(--black)',
                              width: '100%',
                              outline: 'none',
                            }}
                          >
                            <option>Select Role</option>
                            {/* <option value={'Admin'}>Admin</option>
                            <option value={'Accountant'}>Accountant</option>
                            <option value={'Staff'}>Staff</option> */}
                            <option value={'Admin'}>Sub Admin</option>
                            <option value={'Accountant'}>Accountant</option>
                            <option value={'Reservation'}>Reservation</option>
                          </select>
                        </Box>
                      </Grid>
                    </>
                  )}
                </Grid>

                <Button
                  sx={{
                    background: 'var(--mateBlack)',
                    color: '#FFFFFF',
                    width: '370px',
                    mt: '4rem',
                    '&:hover': {
                      backgroundColor: 'var(--mateBlack)',
                    },
                  }}
                  type="submit"
                >
                  Update This Account
                </Button>
              </form>
            </Box>
          </Box>
        </Fade>
      </Modal>
    </Box>
  );
};

export default AccountDetails;
